import { lazy } from 'react';
import PageView from './PageView';

const RolePage = lazy(() => import('src/pages/role'));

export const roleRoutes = [
  {
    path: 'role',
    element: <PageView permission="BO_CAN_VIEW_ROLES" />,
    children: [{ element: <RolePage />, index: true }],
  },
];
